// import { useOrgStore } from '@/stores/org-store';
import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '../../utils/api-request';

interface DeleteSourceResponse {
  data?: {
    status: string;
    message: string;
    organization_id: string;
    collection: string;
    filename: string;
    s3_key: string;
  };
  detail?: string;
}

interface DeleteSourceProps {
  collectionId: string;
  filename: string;
}

export const deleteSource = async ({
  collectionId,
  filename,
}: DeleteSourceProps): Promise<DeleteSourceResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId || !collectionId || !filename) {
    throw new Error(
      'Organization ID, collection name, and filename are required',
    );
  }

  const response = await apiRequest<DeleteSourceResponse>({
    url: `/uploads/${orgId}/${collectionId}/${filename}`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to delete data source',
    };
  }

  return response as DeleteSourceResponse;
};
